import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HomeService } from './home.service';
import { HomeComponent } from './home.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/security/auth.guard';

const routes: Routes = [
  {path:'home',component:HomeComponent, data: { title: 'home'}, canActivate: [AuthGuard]}
];
@NgModule({
  imports: [
    CommonModule, RouterModule.forChild(routes)
  ],
  declarations: [HomeComponent],
  providers :[HomeService]
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts